import { changeAmountEvt } from "../misc/events";

export function initClickableAmountInputForCLDForms() {
    const forms = document.querySelectorAll(".cloudmanufaktur-form");
    if (forms.length === 0) return;

    forms.forEach(form => {
        updateClickableAmountInputs(form)
    })
}

export function updateClickableAmountInputs(form) {
    let amountInputs = form.querySelectorAll(".cloudmanufaktur-form-field-amount-inner")
    amountInputs.forEach(inputHolder => {
        updateClickableAmountInput(inputHolder)
    })
}

export function updateClickableAmountInput(inputHolder) {
    if(!inputHolder) return;
    
    let minusButton = inputHolder.querySelector("button.minus")
    let plusButton = inputHolder.querySelector("button.plus")
    let input = inputHolder.querySelector("input")

    if (input.dataset.min === input.value) {
        minusButton.classList.add("inactive")
    }
    if (input.dataset.max === input.value) {
        plusButton.classList.add("inactive")
    }

    minusButton.addEventListener("click", (e) => {
        e.preventDefault();
        input = inputHolder.querySelector("input")

        if (input.value > 1 && parseInt(input.value) > input.dataset.min) {
            let newValue = parseInt(input.value) - 1
            input.value = newValue;
            input.dataset.value = newValue;
            input.dispatchEvent(changeAmountEvt)
            minusButton.classList.remove("inactive")
            plusButton.classList.remove("inactive")
        } else if (parseInt(input.value) === input.dataset.min) {
            minusButton.classList.add("inactive")
            console.warn(`Less not allowed. Minimum is set to ${input.dataset.min}.`)
        }
    })

    plusButton.addEventListener("click", (e) => {
        e.preventDefault();
        input = inputHolder.querySelector("input")

        if (input.dataset.max === 0 || parseInt(input.value) < input.dataset.max) {
            let newValue = parseInt(input.value) + 1
            input.value = newValue;
            input.dataset.value = newValue;
            input.dispatchEvent(changeAmountEvt)
            plusButton.classList.remove("inactive")
            minusButton.classList.remove("inactive")
            
        } else if (parseInt(input.value) === parseInt(input.dataset.max)) {
            plusButton.classList.add("inactive")
            console.warn(`More not allowed. Max is set to ${input.dataset.max}.`)
        }
    })

    input.addEventListener("change", (e) => {
        if (parseInt(input.value) > input.dataset.max) {
            input.value = input.dataset.max
            plusButton.classList.add("inactive")
            console.warn(`Maximum value is ${input.dataset.max}. You entered a number that's above.`)
        }
    })



    initClickableAmountInput(inputHolder)


}

export function initClickableAmountInput(inputHolder) {
    if(!inputHolder) return; 

    let minusButton = inputHolder.querySelector("button.minus")
    let plusButton = inputHolder.querySelector("button.plus")
    let input = inputHolder.querySelector("input")

    if (parseInt(input.value) < input.dataset.max) {
        plusButton.classList.remove("inactive")
    }

    if (parseInt(input.value) === input.dataset.min) {
        minusButton.classList.add("inactive")
    }
}